import React from 'react';
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { useNavigate } from "react-router-dom";
import DefaultNavbar from 'components/DefaultNavbar';

function Schedule() {
  const navigate = useNavigate();

  useCalendlyEventListener({
    onEventScheduled: (e) => {
      navigate('/schedule/success', { state: { calendlyPayload: e.data.payload } });
    }
  });

  return (
    <>
      <DefaultNavbar />
      <div className="calendly-container" style={{ minWidth: "320px", height: "800px", paddingTop: "80px", paddingBottom: "40px" }}>
        <InlineWidget url="https://calendly.com/osperb/schedule" styles={{ height: "100%", minWidth: "320px" }}
          pageSettings={{
            // backgroundColor: '333333',          // The background of the widget
            hideEventTypeDetails: false,        // Hide the description text
            hideLandingPageDetails: true,      // Hide your avatar and name
            // primaryColor: 'red',             // The color of buttons and links (Osperb blue!)
            // textColor: 'ffffff'                 // Your website's standard body text color
          }}
        // utm={{
        //   utmCampaign: 'Spring Sale 2026',
        //   utmSource: 'Website Profile',
        //   utmMedium: 'Ad',
        //   utmContent: 'Schedule Button',
        //   utmTerm: 'Consulting'
        // }}
        />
      </div>
    </>
  );
}

export default Schedule;
